<script setup lang="ts">
const props = defineProps({
  src: {
    type: String,
    required: true,
  },
  name: {
    type: String,
    required: true,
  },
  tooltip: {
    type: String,
    default: undefined,
  },
  description: {
    type: String,
    default: undefined,
  },
});

const img = useImage();
const url = img(props.src, { width: 128, height: 128 });
</script>

<template>
  <div class="flex flex-col justify-center items-center gap-2">
    <u-tooltip
      v-if="tooltip"
      :text="tooltip"
      :popper="{ arrow: true }"
      class="flex justify-center"
      :ui="{
        base: '[@media(pointer:coarse)]:block',
      }"
    >
      <u-avatar :src="url" size="6xl" :alt="name" img-class="object-cover" />
    </u-tooltip>

    <u-avatar
      v-else
      :src="src"
      size="6xl"
      :alt="name"
      img-class="object-cover"
      :ui="{
        size: {
          custom: 'w-32 h-32 text-2xl',
        },
      }"
    />

    <div class="flex flex-col justify-center text-center">
      <p class="line-clamp-1 text-lg font-bold font-display">{{ name }}</p>
      <p class="opacity-70 text-sm line-clamp-1">{{ description }}</p>
    </div>
  </div>
</template>
